import { Flex } from 'components/base/layout-components';
import useTeams from '../../useTeams';
import useTeamsConfig from '../../useTeamsConfig';
import { TEAM_TYPES } from 'common/constants/constants';
import { submit } from '../TeamsConfig.service';
import MaxContributors from './MaxContributors';
import { LBButton } from '@linearb/buzz';

const Footer = ({
  type,
  isEdit,
  isSaveEnabled,
  setIsSaveEnabled,
  parentGroup = [],
  nestedTeams,
  initialTeamProps,
  teamProps,
  directContributors,
  isWithHistory,
  withoutBackfill,
  maxContributors
}) => {
  const { name, color, initials, isSynced } = teamProps;
  const { goBack } = useTeams();
  const { onSubmit } = useTeamsConfig();
  const parentGroupId = parentGroup[0] === -1 ? -1 : parentGroup[0]?.id;

  const save = async () => {
    setIsSaveEnabled(false);
    await submit({
      onSubmit,
      isEdit,
      isSynced,
      initialTeamProps,
      teamFormValues: {
        color,
        contributor_ids: directContributors.map(({ id }) => id),
        initials,
        name,
        parent_id: parentGroupId,
        teams_ids: nestedTeams.map(({ id }) => id),
        type,
        with_history:
          isEdit && type === TEAM_TYPES.TEAM ? !withoutBackfill : isWithHistory
      }
    });
  };

  return (
    <Flex justify='space-between' pt='medium'>
      <MaxContributors
        maxContributors={maxContributors}
        directContributors={directContributors}
        team={initialTeamProps}
      />
      <Flex gap='1rem'>
        <LBButton variant='outline' onClick={goBack}>
          Cancel
        </LBButton>
        <LBButton disabled={!isSaveEnabled} onClick={save}>
          Save & Close
        </LBButton>
      </Flex>
    </Flex>
  );
};

export default Footer;
